import React from 'react';


export const InfoBox = function(props){
    return <div className="seehi_info">
        {props.text}
    </div>;
}

export const WarningBox = function(props){
    return <div className="seehi_warning">
        {props.text}
    </div>;
}

export const SubsidieBox = function(props){
    const text = props.text instanceof Array? props.text: [props.text];
    return <div className="seehi_info">
        <h3>U komt mogelijk in aanmerking voor de volgende subsidie</h3>
        <ul>
            {text.map((item, i) => (<li key={i}>{item}</li>))}
        </ul>
        <em>
            Benieuwd hoeveel subsidie u precies kunt krijgen? U kunt de rekentool gebruiken op 
            website <a href="https://www.rvo.nl/subsidies-regelingen/seeh/eigenaar-en-bewoner" target="_blank">SEEH voor woningeigenaren</a>. 
            U vindt daar ook alle voorwaarden terug.
        </em>
    </div>;
}



// WEBPACK FOOTER //
// ./src/elements/infoboxes.js